(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aura-premium-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-aura-premium-product]').forEach((section) => {
    if (section.dataset.auraInitialized === 'true') return;
    section.dataset.auraInitialized = 'true';

    const variantsData = section.querySelector('[data-aura-variants]');
    const variants = variantsData ? JSON.parse(variantsData.textContent) : [];
    const currency = section.dataset.currency || 'INR';
    const variantInput = section.querySelector('[data-aura-variant-id]');
    const price = section.querySelector('[data-aura-price]');
    const compare = section.querySelector('[data-aura-compare]');
    const sale = section.querySelector('[data-aura-sale]');
    const inventory = section.querySelector('[data-aura-inventory]');
    const addButton = section.querySelector('[data-aura-add]');
    const addLabel = section.querySelector('[data-aura-add-label]');
    const sticky = section.querySelector('[data-aura-sticky]');
    const stickyButton = section.querySelector('[data-aura-sticky-add]');
    const stickyPrice = section.querySelector('[data-aura-sticky-price]');
    const inStockLabel = section.dataset.inStockLabel;
    const soldOutLabel = section.dataset.soldOutLabel;
    const addToCartLabel = section.dataset.addToCartLabel;
    const offLabel = section.dataset.offLabel;

    const formatMoney = (cents) => new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency,
      maximumFractionDigits: 0
    }).format(cents / 100);

    section.querySelectorAll('[data-aura-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const mediaId = thumb.dataset.auraThumb;
        section.querySelectorAll('[data-aura-media]').forEach((media) => {
          const active = media.dataset.auraMedia === mediaId;
          media.hidden = !active;
          media.classList.toggle('is-active', active);
        });
        section.querySelectorAll('[data-aura-thumb]').forEach((item) => {
          const active = item === thumb;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });
    });

    const quantity = section.querySelector('[data-aura-quantity]');
    section.querySelector('[data-aura-quantity-minus]')?.addEventListener('click', () => {
      quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
    });
    section.querySelector('[data-aura-quantity-plus]')?.addEventListener('click', () => {
      quantity.value = Math.max(1, Number(quantity.value || 1) + 1);
    });

    const updateVariant = () => {
      const selected = Array.from(section.querySelectorAll('[data-option-position]:checked'))
        .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
        .map((input) => input.value);
      const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
      if (!variant) return;

      variantInput.value = variant.id;
      price.textContent = formatMoney(variant.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      compare.classList.toggle('is-hidden', !onSale);
      sale.classList.toggle('is-hidden', !onSale);

      if (onSale) {
        compare.textContent = formatMoney(variant.compare_at_price);
        const discount = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
        sale.textContent = discount + '% ' + offLabel;
      }

      addButton.disabled = !variant.available;
      if (stickyButton) {
        stickyButton.disabled = !variant.available;
        stickyButton.textContent = variant.available ? addToCartLabel : soldOutLabel;
      }
      inventory.classList.toggle('is-sold-out', !variant.available);
      inventory.lastChild.textContent = variant.available ? inStockLabel : soldOutLabel;
      addLabel.textContent = variant.available ? addToCartLabel : soldOutLabel;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    section.querySelectorAll('[data-option-position]').forEach((input) => {
      input.addEventListener('change', updateVariant);
    });

    if (sticky && stickyButton && addButton) {
      stickyButton.addEventListener('click', () => addButton.click());
      const buyObserver = new IntersectionObserver((entries) => {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: .2 });
      buyObserver.observe(addButton);
    }

    const recommendations = section.querySelector('[data-aura-recommendations]');
    if (recommendations && !recommendations.innerHTML.trim()) {
      const observer = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        fetch(recommendations.dataset.url)
          .then((response) => response.text())
          .then((htmlText) => {
            const html = new DOMParser().parseFromString(htmlText, 'text/html');
            const replacement = html.querySelector('[data-aura-recommendations]');
            if (replacement) recommendations.innerHTML = replacement.innerHTML;
          });
      }, { rootMargin: '300px 0px' });
      observer.observe(recommendations);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aura-refined-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new WeakMap();
  const init = (root) => {
    root.querySelectorAll('[data-arf-product]').forEach((section) => {
      if (instances.has(section)) return;
      const abort = new AbortController();
      const signal = abort.signal;
      const slides = [...section.querySelectorAll('[data-arf-media]')];
      const thumbs = [...section.querySelectorAll('[data-arf-thumb]')];
      const stage = section.querySelector('[data-arf-stage]');
      const form = section.querySelector('form');
      const add = section.querySelector('[data-arf-add]');
      const sticky = section.querySelector('[data-arf-sticky]');
      const stickyAdd = section.querySelector('[data-arf-sticky-add]');
      const qty = section.querySelector('[data-arf-quantity]');
      let index = Math.max(0, slides.findIndex((s) => !s.hidden));
      const show = (next) => {
        if (!slides.length) return;
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== index; if (i !== index) slide.querySelectorAll('video').forEach((video) => video.pause()); });
        thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === index)));
        const counter = section.querySelector('[data-arf-counter]');
        if (counter) counter.textContent = index + 1;
      };
      show(index);
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', (event) => { event.preventDefault(); show(i); }, {signal}));
      section.querySelector('[data-arf-prev]')?.addEventListener('click', () => show(index - 1), {signal});
      section.querySelector('[data-arf-next]')?.addEventListener('click', () => show(index + 1), {signal});
      let startX = 0, startY = 0;
      stage?.addEventListener('touchstart', (e) => { startX = e.changedTouches[0].clientX; startY = e.changedTouches[0].clientY; }, {signal, passive:true});
      stage?.addEventListener('touchend', (e) => { if (e.target.closest('video,iframe,model-viewer,button')) return; const dx=e.changedTouches[0].clientX-startX,dy=e.changedTouches[0].clientY-startY;if(Math.abs(dx)>55 && Math.abs(dx)>Math.abs(dy)*1.5)show(index+(dx<0?1:-1)); }, {signal, passive:true});
      section.querySelector('[data-arf-minus]')?.addEventListener('click', () => { qty.stepDown(); qty.dispatchEvent(new Event('change',{bubbles:true})); }, {signal});
      section.querySelector('[data-arf-plus]')?.addEventListener('click', () => { qty.stepUp(); qty.dispatchEvent(new Event('change',{bubbles:true})); }, {signal});
      const select = section.querySelector('[data-arf-select]');
      select?.addEventListener('change', () => {
        const option = select.selectedOptions[0]; if (!option) return;
        const available = option.dataset.available === 'true';
        section.querySelector('[data-arf-price]').textContent=option.dataset.price;
        section.querySelector('[data-arf-sticky-price]').textContent=option.dataset.price;
        const compare=section.querySelector('[data-arf-compare]'),saving=section.querySelector('[data-arf-saving]');
        compare.hidden=!option.dataset.saving;saving.hidden=!option.dataset.saving;compare.textContent=option.dataset.compare;saving.textContent=option.dataset.saving;
        add.disabled=!available;stickyAdd.disabled=!available;
        const label=available?section.dataset.addLabel:section.dataset.soldLabel;
        section.querySelector('[data-arf-add-text]').textContent=label;stickyAdd.textContent=label;
        section.querySelector('[data-arf-stock]').textContent=available?section.dataset.availableLabel:section.dataset.soldLabel;
        qty.min=option.dataset.min||'1';qty.step=option.dataset.step||'1';qty.value=qty.min;
        if(option.dataset.max)qty.max=option.dataset.max;else qty.removeAttribute('max');
        if(option.dataset.media){const mediaIndex=slides.findIndex(s=>s.dataset.arfMedia===option.dataset.media);if(mediaIndex>=0)show(mediaIndex);}
        const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);
      }, {signal});
      const observer = new IntersectionObserver(() => { sticky.hidden = add.getBoundingClientRect().bottom > 0; }, {threshold:[0,1]});
      if(add && sticky) observer.observe(add);
      instances.set(section,{abort,observer});
      form?.addEventListener('submit', () => { if(!form.checkValidity())return; }, {signal});
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll('[data-arf-product]').forEach(section=>{const item=instances.get(section);item?.abort.abort();item?.observer.disconnect();instances.delete(section);}));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aura-refined-related"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init = root => root.querySelectorAll('[data-arf-related]').forEach(section => {
  if(section.dataset.arfLoaded)return;section.dataset.arfLoaded='true';
  const observer=new IntersectionObserver(entries=>{if(!entries.some(e=>e.isIntersecting))return;observer.disconnect();fetch(section.dataset.url).then(r=>{if(!r.ok)throw new Error('Recommendations unavailable');return r.text()}).then(text=>{if(!section.isConnected)return;const html=new DOMParser().parseFromString(text,'text/html');const grid=html.querySelector('[data-arf-related-grid]');if(grid?.children.length)section.querySelector('[data-arf-related-grid]').replaceChildren(...grid.children)}).catch(()=>{});},{rootMargin:'250px'});observer.observe(section);
  section.addEventListener('shopify:section:unload',()=>observer.disconnect(),{once:true});
 });init(document);document.addEventListener('shopify:section:load',e=>init(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aura-refined-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const formatReviews = (root) => {
    root.querySelectorAll('.jdgm-rev-widg__summary-average').forEach((element) => {
      const rating = Number.parseFloat(element.textContent);
      if (!Number.isFinite(rating)) return;
      const display = `${rating.toFixed(1)} / 5.0`;
      if (element.textContent !== display) element.textContent = display;
    });
  };
  const initialize = () => document.querySelectorAll('.arr').forEach((root) => {
    if (root.dataset.ratingFormatReady) return;
    root.dataset.ratingFormatReady = 'true';
    formatReviews(root);
    const observer = new MutationObserver(() => {
      if (!root.isConnected) { observer.disconnect(); return; }
      formatReviews(root);
    });
    observer.observe(root, { childList: true, subtree: true, characterData: true });
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.contains(root)) observer.disconnect();
    }, { once: true });
  });
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
